export const config = {
  title: "Ayala's Landscaping LLC | Landscaping Services in Virginia, USA",
  meta: {
    description:
      "Ayala's Landscaping LLC offers professional landscaping services in Virginia, USA. We specialize in outdoor design, lawn care, pavers installation, and seasonal services to enhance your property's beauty.",
    keywords: [
      "Landscaping Services Virginia",
      "Outdoor Design",
      "Pavers Installation",
      "Gardening Services",
      "Lawn Care Virginia",
      "Fencing Installation",
      "Ayala's Landscaping LLC",
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "Ayala's Landscaping LLC",
    canonicalUrl: "https://ayalaslandscapingllc.com/",
  },
  sections: {
    header: {
      businessName: "Ayala's Landscaping LLC",
    },
    sectionB: {
      heroTitle: "Ayala's Landscaping LLC",
      heroSubtitle: "Transforming Your Outdoor Spaces with Professional Landscaping Services",
      learnAboutText: 'Explore Services',
      phoneNumber: "4345312076",
      phoneLabel: "(434) 531-2076",
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1418465051/photo/aerial-view-of-modern-backyard-with-vegetable-garden.jpg?s=612x612&w=0&k=20&c=a_3DxsLc_F_OS4M3CtUWia2mFNgqErFCFYBm9qiYs4k=',
      cardData: [
        {
          title: "Creative Landscape Design",
          description:
            "We design outdoor spaces that reflect your style and enhance the beauty of your property.",
        },
        {
          title: "Pavers and Brick Installation",
          description:
            "Expertly crafted pathways and patios for durability and elegance.",
        },
        {
          title: "Comprehensive Lawn Care",
          description:
            "From mowing to mulching, we provide all the care your lawn needs to thrive.",
        },
      ],
      description:
        "Ayala's Landscaping LLC provides expert landscaping services, including design, installation, and maintenance. Our commitment to quality ensures your outdoor spaces are beautiful and functional.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "We are dedicated to providing top-notch landscaping solutions tailored to your unique needs. Explore our services and see how we can help enhance your outdoor spaces.",
      cards: [
        {
          title: 'Landscaping Services',
          description:
            "We specialize in transforming outdoor spaces with expert landscaping design and installation services.",
          imageSrc:
            'https://ayalaslandscapingllc.com/wp-content/uploads/2025/01/1646839986_18-idei-club-p-krasivie-luzhaiki-pered-domom-interer-kras-20-1536x1017.jpg',
          imageAlt: 'Landscaping Services',
        },
        {
          title: 'Outdoor Surfaces',
          description:
            "Create stunning, durable pathways and patios with our high-quality pavers installation service.",
          imageSrc:
            'https://ayalaslandscapingllc.com/wp-content/uploads/2025/01/3-2-1536x1017.png',
          imageAlt: 'Pavers Installation',
        },
        {
          title: 'Gardening & Lawn Care',
          description:
            "Enhance your property with lush greenery, regular lawn maintenance, and expert garden care.",
          imageSrc:
            'https://ayalaslandscapingllc.com/wp-content/uploads/2025/01/2-3-1536x1017.png',
            imageAlt: "Gardening Services",
          },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Seasonal Services',
        'Fencing Installation',
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://ayalaslandscapingllc.com/wp-content/uploads/2025/01/how-many-patio-blocks-do-i-need-1701256032.jpg",
        alt: "Ayala's Landscaping LLC Team",
      },
      aboutText: [
        "At Ayala’s Landscaping LLC, we take pride in a rich history of innovation, dedication, and customer satisfaction. Our journey began with a simple mission: to deliver unparalleled quality and value to our clients.",
        "Our goal is to be a leader in the landscaping industry, setting new benchmarks for quality, creativity, and customer satisfaction. We empower our clients with innovative outdoor solutions and exceptional service, ensuring a beautifully maintained landscape year-round.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Ayala's Landscaping LLC Logo",
      businessName: "Ayala's Landscaping LLC",
      contact: {
        phone: "4345312076",
        phoneLabel: "(434) 531-2076",
        email: "ricardoayala187@yahoo.com",
        website: "https://ayalaslandscapingllc.com/",
        address: "3203 Columbia Road, Zion Crossroads, Virginia 22942",
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: "https://www.facebook.com/1Ricardo65",
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "3203 Columbia Road, Zion Crossroads, Virginia 22942",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3068.5760110136727!2d-78.63521!3d33.87091!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDUyJzE1LjciTiA3OMKwMzgnMTEuNCJX!5e0!3m2!1sen!2sus!4v1614123456789",
    },
  },
};

export default config;